import {LocaleEnum} from "@app/enums/LocaleEnum";

export enum CountryEnum {
  SLOVENIA = 'si',
  CROATIA = 'hr',
  GREAT_BRITAIN = 'gb',
  GERMANY = 'de',

  PT = 'pt',
  AT = 'at',
  FR = 'fr',
  IT = 'it',
  ES = 'es',
  PL = 'pl',
  NL = 'nl',
  CZ = 'cz',
  SK = 'sk',
  BE = 'be',
}

export const CountryEnumToLocale = {
  [CountryEnum.SLOVENIA]: LocaleEnum.LOCALE_SI,
  [CountryEnum.CROATIA]: LocaleEnum.LOCALE_HR,
  [CountryEnum.GERMANY]: LocaleEnum.LOCALE_DE,
  [CountryEnum.GREAT_BRITAIN]: LocaleEnum.LOCALE_EN,
}

export function countryCodeToLocale(countryCode: string): string {
  return CountryEnumToLocale[countryCode] || LocaleEnum.LOCALE_EN;
}
